import BenCollapseLoaderStub from "./ben-collapse-loader-stub";

export default BenCollapseLoaderStub;
